// components/ExpandedContent.tsx
import React from "react";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import BranchGroup from "./BranchGroup";
import { ClassLevel } from "types/classLevelTypes";
import { groupByBranch } from "utils/schoolUtils";

type Props = {
  record: ClassLevel;
  onDelete: (id: string) => void;
};

const ExpandedContent: React.FC<Props> = ({ record, onDelete }) => {
  const { t } = useTranslation();
  const list = (record.subjectCoefficient ?? []).filter((item: any) => item.optional !== true);

  if (!list.length) {
    return <Alert message={t("no_subject_coefficients_found")} type="info" showIcon />;
  }

  // Branch grouping
  let groups = groupByBranch(list, t("base_subjects"));
  // If you want to hide duplicates from base when they exist in branches, enable:
  // groups = filterBaseDuplicates(groups);

  // base first, then branches A->Z
  groups.sort((a : any, b : any) => {
    if (a.branchId === null && b.branchId !== null) return -1;
    if (a.branchId !== null && b.branchId === null) return 1;
    return a.branchName.localeCompare(b.branchName);
  });

  return (
    <div className="p-2">
      {groups.map((group : any) => (
        <BranchGroup key={group.branchId ?? "no_branch"} branchGroup={group} onDelete={onDelete} />
      ))}
    </div>
  );
};

export default ExpandedContent;
